import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from './common/LoadingSpinner';

/**
 * App root: the app serves no marketing pages. Signed-in users go to the
 * dashboard, everyone else to the login page.
 */
export default function AppRootRedirect() {
  const { isAuthenticated, loading } = useSelector((state) => state.auth);

  if (loading) {
    return <LoadingSpinner />;
  }

  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
}
